const {system, ...state} = window.__INITIAL_STATE__;
const config = {
    ...state,
    ...system,
    hacid: null,
    edn: null,
};

export default config;
